export default __webpack_public_path__ + "9c45f44ffb5bbb5e49b87a09a83bb450.png";